module.exports = __webpack_public_path__ + "img/op4.0c322ceb.png";